<template>
    <v-dialog
        :value="show"
        id="captcha-dialog"
        max-width="358px"
        overlay-color="#909090"
        overlay-opacity="1"
        z-index="1000"
    >
        <v-card>
            <v-toolbar color="primary" dark flat>
                <v-toolbar-title>
                    Captcha
                </v-toolbar-title>
            </v-toolbar>
            <v-card-text class="mt-3">
                <div id="px-captcha"></div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
    computed: {
      ...mapState('captcha', [
          'show'
      ]),
    },
};
</script>

<style scoped>
  #captcha-dialog {
    z-index: 1000;
  }
</style>
